import { getMacroWidget } from "../private/api/getMacroWidget";
import { getTopGainersWidget } from "../private/api/getTopGainersWidget";
import { getTopMentionedCoins } from "../private/api/getTopMentionedCoins";

const PulseMarket = {
  namespaced: true,

  state: {
    macroData: [],
    gainersData: [],
    mentionsData: [],
    loading: {
      macro: false,
      gainers: false,
      mentions: false
    },
    ready: {
      macro: false,
      gainers: false,
      mentions: false
    },
    error: {
      macro: null,
      gainers: null,
      mentions: null
    }
  },

  actions: {
    //Запрашивает и сохраняет данные макро-виджета
    async fetchMacroData({ commit }) {
      commit('SET_LOADING', { type: 'macro', value: true });
      commit('SET_ERROR', { type: 'macro', value: null });
      
      try {
        const data = await getMacroWidget();
        commit('SET_MACRO_DATA', data);
        commit('TO_UPDATE_MACRO_DATA')
        commit('SET_READY', { type: 'macro', value: true } )
      } catch (error) {
        commit('SET_ERROR', { type: 'macro', value: error.message });
        console.error('Error fetching macro data:', error);
      } finally {
        commit('SET_LOADING', { type: 'macro', value: false });
      }
    },
    //Запрашивает и сохраняет данные топ-гейнеров
    async fetchTopGainers({ commit }) {
      commit('SET_LOADING', { type: 'gainers', value: true });
      commit('SET_ERROR', { type: 'gainers', value: null });
      
      try {
        const data = await getTopGainersWidget();
        console.log(data);
        if(!data || data.length === 0) return;
        commit('SET_GAINERS_DATA', data);
        commit('SET_READY', { type: 'gainers', value: true } )
      } catch (error) {
        commit('SET_ERROR', { type: 'gainers', value: error.message });
        console.error('Error fetching top gainers:', error);
      } finally {
        commit('SET_LOADING', { type: 'gainers', value: false });
      }
    },
    //Запрашивает и сохраняет данные топ-упоминаний
    async fetchTopMentions({ commit }) {
      commit('SET_LOADING', { type: 'mentions', value: true });
      commit('SET_ERROR', { type: 'mentions', value: null });
      try {
        const data = await getTopMentionedCoins();
        if(!data || data.length === 0) return;
        commit('SET_MENTIONS_DATA', data);
        commit('SET_READY', { type: 'mentions', value: true } )
      } catch (error) {
        commit('SET_ERROR', { type: 'mentions', value: error.message });
        console.error('Error fetching top mentions:', error);
      } finally {
        commit('SET_LOADING', { type: 'mentions', value: false });
      }
    },
    //Параллельно загружает все данные виджетов
    async fetchAllData({ dispatch }) {
      await Promise.all([
        dispatch('fetchMacroData'),
        dispatch('fetchTopGainers'),
        dispatch('fetchTopMentions')
      ]);
    }
  },

  mutations: {
    //Сохраняет данные макро-виджета
    SET_MACRO_DATA(state, data) {
      state.macroData = data;
    },
    
    //Сохраняет данные топ-гейнеров
    SET_GAINERS_DATA(state, data) {
      state.gainersData = data;
    },
    
    //Сохраняет данные топ-упоминаний
    SET_MENTIONS_DATA(state, data) {
      state.mentionsData = data;
    },
    
    //Устанавливает состояние загрузки для конкретного виджета
    SET_LOADING(state, { type, value }) {
      state.loading[type] = value;
    },

    //Устанавливает статус готовности для конкретного виджета
    SET_READY(state, { type, value }) {
      state.ready[type] = value;
    },
    
    //Устанавливает ошибку для конкретного виджета
    SET_ERROR(state, { type, value }) {
      state.error[type] = value;
    },

    //Обновить макро данные
    TO_UPDATE_MACRO_DATA(state){
      for (const slug in state.macroData){
        if(slug === 'btc' || slug === 'eth' || slug === 'sol'){
          state.macroData[slug]['price'] = state.macroData[slug]['price_usd'];
          state.macroData[slug]['change_1d'] = state.macroData[slug]['change_1d_usd'];
        }
        if(slug === 'btc'){
          state.macroData[slug]['frontIcon'] = 'btc';
        } else if(slug === 'eth'){
          state.macroData[slug]['frontIcon'] = 'eth';
        } else if(slug === 'sol'){
          state.macroData[slug]['frontIcon'] = 'sol';
        } else if(slug === 'gold'){
          state.macroData[slug]['symbol'] = 'Gold';
          state.macroData[slug]['frontIcon'] = 'gold';
        } else if(slug === 'market_cap'){
          state.macroData[slug]['symbol'] = 'MCap';
          state.macroData[slug]['frontIcon'] = 'market_cap';
        } else if(slug === 'nvidia'){
          state.macroData[slug]['symbol'] = 'Nvidia';
          state.macroData[slug]['frontIcon'] = 'nvidia';
        } else if(slug === 'rub'){
          state.macroData[slug]['symbol'] = 'RUB';
          state.macroData[slug]['frontIcon'] = 'rub';
        } else if(slug === 'sp500'){
          state.macroData[slug]['symbol'] = 'SP500';
          state.macroData[slug]['frontIcon'] = 'sp500';
        }
      }
    }
  },

  getters: {
    //Проверяет, нужно ли загружать макро-данные (нет загрузки и нет данных)
    shouldFetchMacro: (state) => {
      return !state.loading.macro && state.macroData.length === 0;
    },

    //Проверяет, нужно ли загружать топ гейнеров (нет загрузки и нет данных)
    shouldFetchGainers: (state) => {
      return !state.loading.gainers && state.gainersData.length === 0;
    },

    //Проверяет, нужно ли загружать топ упоминаний (нет загрузки и нет данных)
    shouldFetchMentions: (state) => {
      return !state.loading.mentions && state.mentionsData.length === 0;
    },
  }

}

export default PulseMarket;